import excel from "assets/img/file_excel.png";
import other from "assets/img/file_other.png";
import pdf from "assets/img/file_pdf.png";
import ppt from "assets/img/file_pp.png";
import video from "assets/img/file_video.png";
import word from "assets/img/file_word.png";
import folder from "assets/img/folder.png";
import { PreviewImage } from "components/PreviewImage";
import removeDiacritics from "helper/remove-diacritics";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import React from "react";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import { AppSettings } from "../../constants";
import * as WorkOrderActionType from "../constants";
// import PDFViewer from '../../components/PDF/index';
import { isMobile } from "react-device-detect";
import { v4 as uuidv4 } from "uuid";
import * as PubSubActionType from "../../services/constants";
import PubSub from "../../services/pubsub-service";
import ImageConvertor from "../../utils/ImageConvertor";
import PreviewVideoWO from "../Components/PreviewVideoWO";
const MAXIMUM_FILE_SIZE = 1024 * 1024 * 10; //10MB

class WorkOrderFiles extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    history: PropTypes.object,
    WorkOrderCredentials: PropTypes.object,
    WorkOrderProfile: PropTypes.object,
    WorkOrderAttachments: PropTypes.array,
    workOrderId: PropTypes.any,
    rfsId: PropTypes.any,
    LotStore: PropTypes.object,
    readOnly: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      showDialog: false,
      previewUrl: null,
      isPreviewPDF: null,
      videoUrl: null,
      files: [],
      cancelUploadList: {},
      deleteUploadList: {},
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleHideEmbedPreview);

    if (this.props.readOnly) {
      window.addEventListener(
        "dragover",
        (e) => {
          e.preventDefault();
        },
        false
      );
      window.addEventListener(
        "drop",
        (e) => {
          e.preventDefault();
        },
        false
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.WorkOrderAttachments &&
      nextProps.WorkOrderAttachments.length
    ) {
      const attachments = nextProps.WorkOrderAttachments;
      attachments.map((item) => {
        this.setState({
          [item.id]: item.caption,
        });
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleHideEmbedPreview);
    this.props.dispatch({
      type: WorkOrderActionType.RESET_ATTACHMENTS,
    });
  }

  compareFileName = (a, b) => {
    const nameA = a.fileName.toLowerCase();
    const nameB = b.fileName.toLowerCase();

    if (nameA < nameB) {
      return -1;
    }

    if (nameA > nameB) {
      return 1;
    }

    return 0;
  };

  uploadAttachmentsToServer = (data, fileName) => {
    const { rfsId, workOrderId } = this.props;

    this.props.dispatch({
      type: WorkOrderActionType.UPLOAD_TO_SERVER_ASYNC,
      params: {
        refNo: workOrderId,
        rfsId,
        data: {
          url: data.Location,
          key: data.Key,
          fileName: fileName,
        },
      },
      callback: (res) => {
        this.setState({
          files: this.state.files.filter(
            (element) => element.name !== res.fileName
          ),
        });
      },
    });
  };

  downloadFileFromS3 = (file) => () => {
    if (AppSettings.clientTypeValue === "Subcontractor") {
      const {
        WorkOrderProfile: { builderProfile },
      } = this.props;
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_SUBCONTRACTOR_AWS_S3_ASYNC,
        params: {
          data: {
            resourcePath: `work-order/${this.props.workOrderId}`,
          },
          endpoint: builderProfile.s3SredentialsEndpoint,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken,
          },
        },
        callback: () => {
          this.props.dispatch({
            type: WorkOrderActionType.DOWNLOAD_FILE_FROM_S3,
            params: {
              config: this.props.WorkOrderCredentials,
              fileName: file.fileName,
              key: file.key,
            },
          });
        },
      });
    } else if (AppSettings.clientTypeValue === "Builder") {
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_AWS_S3_ASYNC,
        params: { resourcePath: `work-order/${this.props.workOrderId}` },
        callback: () => {
          this.props.dispatch({
            type: WorkOrderActionType.DOWNLOAD_FILE_FROM_S3,
            params: {
              config: this.props.WorkOrderCredentials,
              fileName: file.fileName,
              key: file.key,
            },
          });
        },
      });
    } else {
      const lotFound = this.props.LotStore.HomeownerLots.find(
        (item) =>
          item.lot.id === this.props.WorkOrderProfile.requestDetail.lot.id
      );
      const { builderProfile } = lotFound;
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_HOMEOWNER_AWS_S3_ASYNC,
        params: {
          data: {
            resourcePath: `work-order/${this.props.workOrderId}`,
          },
          endpoint: builderProfile.builderHost,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken,
          },
        },
        callback: (status, config) => {
          if (status) {
            this.props.dispatch({
              type: WorkOrderActionType.DOWNLOAD_FILE_FROM_S3,
              params: {
                config,
                fileName: file.fileName,
                key: file.key,
              },
            });
          }
        },
      });
    }
  };

  uploadFileToS3 = (e) => {
    if (AppSettings.clientTypeValue === "Subcontractor") {
      const {
        WorkOrderProfile: { builderProfile },
      } = this.props;
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_SUBCONTRACTOR_AWS_S3_ASYNC,
        params: {
          data: {
            resourcePath: `work-order/${this.props.workOrderId}`,
          },
          endpoint: builderProfile.s3SredentialsEndpoint,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken,
          },
        },
        callback: () => {
          this.state.files.map((file) => {
            this.props.dispatch({
              type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
              params: {
                refNo: this.props.workOrderId,
                config: this.props.WorkOrderCredentials,
                file: file,
              },
              callback: this.onUploadFileCallback(file.name),
            });
          });
        },
      });
    } else if (AppSettings.clientTypeValue === "Builder") {
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_AWS_S3_ASYNC,
        params: { resourcePath: `work-order/${this.props.workOrderId}` },
        callback: () => {
          this.state.files.map((file) => {
            this.props.dispatch({
              type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
              params: {
                refNo: this.props.workOrderId,
                config: this.props.WorkOrderCredentials,
                file: file,
              },
              callback: this.onUploadFileCallback(file.name),
            });
          });
        },
      });
    } else {
      const lotFound = this.props.LotStore.HomeownerLots.find(
        (item) =>
          item.lot.id === this.props.WorkOrderProfile.requestDetail.lot.id
      );
      const { builderProfile } = lotFound;
      this.props.dispatch({
        type: WorkOrderActionType.SETUP_HOMEOWNER_AWS_S3_ASYNC,
        params: {
          data: {
            resourcePath: `work-order/${this.props.workOrderId}`,
          },
          endpoint: builderProfile.builderHost,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken,
          },
        },
        callback: (status, config) => {
          if (status) {
            this.state.files.map((file) => {
              this.props.dispatch({
                type: WorkOrderActionType.UPLOAD_FILE_WORK_ORDER_ASYNC,
                params: {
                  refNo: this.props.workOrderId,
                  config,
                  file: file,
                },
                callback: this.onUploadFileCallback(file.name),
              });
            });
          }
        },
      });
    }
  };

  onUploadFileCallback = (fileName) => (status, data) => {
    if (status === "pending") {
      const { cancelUploadList } = this.state;
      cancelUploadList[data.uploadId] = data.cancelUpload;
      this.setState({
        cancelUploadList,
      });
    } else if (status === "delete") {
      const { deleteUploadList } = this.state;
      deleteUploadList[data.uploadId] = data.deleteFile;
      this.setState({
        deleteUploadList,
      });
    } else {
      this.uploadAttachmentsToServer(data.data, fileName);
    }
  };
  showLoading = () => {
    PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
      isHideIndicator: true,
    });
  };
  hideLoading = () => {
    PubSub.publish(PubSubActionType.LOADING_INDICATOR, {
      isHideIndicator: false,
    });
  };
  onDrop = (e) => {
    this.showLoading();
    let newFiles = this.state.files;
    let errorFile = null;
    try {
      e.map(async (file) => {
        const fileExtention = file.name.split(".").pop();
        if (fileExtention === "heif" || fileExtention === "heic") {
          /*HEIF or HEIC file convert to jpeg with package*/
          let convertedFile = await ImageConvertor.convertImage(file);
          let replaceFileName = `${file.name.split(".")[0]}.jpeg`;
          const blobToFile = new File([convertedFile], replaceFileName);
          if (blobToFile.size > MAXIMUM_FILE_SIZE) {
            errorFile = "File size must not exceed 10MB.";
          } else {
            blobToFile["id"] = uuidv4();
            newFiles.push(blobToFile);
            this.setState(
              {
                files: newFiles,
              },
              () => {
                this.uploadFileToS3(e);
              }
            );
          }
        } else {
          if (file.size > MAXIMUM_FILE_SIZE) {
            errorFile = "File size must not exceed 10MB.";
          } else {
            file["id"] = uuidv4();
            console.log("updatedFileName", file);
            newFiles.push(file);

            this.setState(
              {
                files: newFiles,
              },
              () => {
                this.uploadFileToS3(e);
              }
            );
          }
        }
      });
      this.hideLoading();
    } catch (e) {
      this.hideLoading();
    }
  };
  handleCancel = (item) => {
    const { cancelUploadList } = this.state;
    if (
      !isEmpty(cancelUploadList) &&
      Object.keys(cancelUploadList).includes(item.uploadId)
    ) {
      cancelUploadList[item.uploadId]();
      delete cancelUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter(
          (element) => element.uploadId !== item.uploadId
        ),
        cancelUploadList,
      });
    }
    const { deleteUploadList } = this.state;
    if (
      !isEmpty(deleteUploadList) &&
      Object.keys(deleteUploadList).includes(item.uploadId)
    ) {
      deleteUploadList[item.uploadId]();
      delete deleteUploadList[item.uploadId];
      this.setState({
        files: this.state.files.filter(
          (element) => element.uploadId !== item.uploadId
        ),
        deleteUploadList,
      });
    }
  };

  onSaveCaption = (originalCaption, attachmentId, caption, index) => {
    if (originalCaption !== caption) {
      this.props.dispatch({
        type: WorkOrderActionType.UPDATE_CAPTION_ATTACHMENT_WORK_ORDER_ASYNC,
        params: {
          refNo: this.props.workOrderId,
          id: attachmentId,
          data: {
            caption: caption,
          },
        },
        callback: () => {
          this.setState({
            [index]: false,
          });
        },
      });
    } else {
      this.setState({
        [index]: false,
      });
    }
  };

  onEnter = (e, originalCaption, attachmentId, caption, index) => {
    if (e.key === "Enter") {
      this.onSaveCaption(originalCaption, attachmentId, caption, index);
    }
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  handleCloseVideo = (callback) => {
    this.setState({ showDialog: false, videoUrl: null }, callback);
  };

  handleShow = (url) => {
    const imageType = ["jpg", "jpeg", "png", "gif"];
    const videoType = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];
    if (imageType.includes(url.split(".").pop().toLowerCase())) {
      this.setState({
        show: true,
        previewUrl: url,
      });
    }
    if (url.split(".").pop().toLowerCase() === "pdf") {
      this.setState(
        {
          isPreviewPDF: url,
        },
        () => {
          if (isMobile) {
            window.open(this.state.isPreviewPDF, "_blank");
          }
        }
      );
    }
    if (videoType.includes(url.split(".").pop().toLowerCase())) {
      this.setState({
        showDialog: true,
        videoUrl: url,
      });
    }
  };

  handleHideEmbedPreview = (event) => {
    if (this.embedPreview && !this.embedPreview.contains(event.target)) {
      this.setState({
        isPreviewPDF: null,
      });
    }
  };

  onClosePDFViewer = () => {
    this.setState({
      isPreviewPDF: null,
    });
  };

  renderFileTypeIcon = (item) => {
    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const extImage = ["jpg", "jpeg", "png", "gif"];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];
    const ext = item.key.split(".").pop().toLowerCase();
    if (extWord.includes(ext)) {
      return { backgroundImage: `url(${word})` };
    } else if (extExcel.includes(ext)) {
      return { backgroundImage: `url(${excel})` };
    } else if (extPpt.includes(ext)) {
      return { backgroundImage: `url(${ppt})` };
    } else if (extPpt.includes(ext)) {
      return { backgroundImage: `url(${ppt})` };
    } else if (extVideo.includes(ext)) {
      return { backgroundImage: `url(${video})` };
    } else if (ext === "pdf") {
      return { backgroundImage: `url(${pdf})` };
    } else if (extImage.includes(ext)) {
      return { backgroundImage: `url(${item.url})`, backgroundSize: "cover" };
    } else {
      return { backgroundImage: `url(${other})` };
    }
  };

  renderFileTypeUploading = (item) => {
    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const extImage = ["jpg", "jpeg", "png", "gif"];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];
    const ext = item.name.split(".").pop().toLowerCase();
    let style = {};
    if (extWord.includes(ext)) {
      style = { backgroundImage: `url(${word})` };
    } else if (extExcel.includes(ext)) {
      style = { backgroundImage: `url(${excel})` };
    } else if (extPpt.includes(ext)) {
      style = { backgroundImage: `url(${ppt})` };
    } else if (extPpt.includes(ext)) {
      style = { backgroundImage: `url(${ppt})` };
    } else if (extVideo.includes(ext)) {
      style = { backgroundImage: `url(${video})` };
    } else if (ext === "pdf") {
      style = { backgroundImage: `url(${pdf})` };
    } else if (extImage.includes(ext)) {
      style = {
        backgroundImage: `url(${item.preview})`,
        backgroundSize: "cover",
      };
    } else {
      style = { backgroundImage: `url(${other})` };
    }
    style = { ...style, opacity: 0.6 };
    return style;
  };

  noFileStyle = () => {
    let style = {};

    if (
      !this.props.WorkOrderAttachments.length &&
      this.state.files.length === 0
    ) {
      style = {
        background: "#f2f2f2",
        opacity: "0.4",
      };
    }

    if (this.props.readOnly) {
      style["height"] = "640px";
    }

    return style;
  };

  render() {
    const { show, previewUrl } = this.state;
    return (
      <div className="col-xs-12 col-sm-4 col-lg-4 wo-files-panel">
        {/* {this.state.isPreviewPDF && this.isMobile && window.open(this.state.isPreviewPDF, '_about_blank')} */}
        {this.state.isPreviewPDF &&
          !isMobile && [
            <embed
              src={this.state.isPreviewPDF}
              className="pdf-preview-dialog"
              ref={(ref) => {
                this.embedPreview = ref;
              }}
            />,
            <i className="close-embed-preview fa fa-close" />,
          ]}

        <PreviewImage
          show={show}
          imageUrl={previewUrl}
          handleClose={this.handleClose}
          isPDF={false}
        />

        {this.state.videoUrl && [
          <PreviewVideoWO
            // loading
            data={this.state.videoUrl}
            showDialog={this.state.showDialog}
            handleCloseVideo={this.handleCloseVideo}
          />,
        ]}

        <div className="box-form-siteone work-order-files-wrapper">
          <label className="files-header">Files</label>
          <Dropzone
            disableClick
            ref={(node) => {
              this.dropzoneRef = node;
            }}
            disabled={this.props.readOnly}
            noDrag={this.props.readOnly}
            onDrop={this.onDrop}
            style={{ position: "initial" }}
          >
            <div className="files-body" style={this.noFileStyle()}>
              {this.props.WorkOrderAttachments.length ||
              this.state.files.length ? (
                this.props.WorkOrderAttachments.sort(this.compareFileName).map(
                  (item, index) => (
                    <div className="file-item col-xs-12" key={index}>
                      <div className="item-thumbnail-wrapper">
                        <div
                          className="item-thumbnail"
                          onDoubleClick={() => this.handleShow(item.url)}
                          style={this.renderFileTypeIcon(item)}
                        />
                        <div className="item-fade" />
                        <i
                          className="fa fa-arrow-down remove-icon func-icon"
                          onClick={this.downloadFileFromS3(item)}
                        />
                        <i
                          className="fa fa-eye view-icon func-icon"
                          onClick={() => this.handleShow(item.url)}
                          ref={(ref) => {
                            this.viewIcon = ref;
                          }}
                        />
                      </div>
                      <div
                        className="col-xs-12"
                        style={{ padding: 0, marginTop: 5 }}
                      >
                        <p className="item-name col-xs-9">
                          {removeDiacritics(item.fileName)}
                        </p>
                      </div>
                      <div className="col-xs-12" style={{ padding: 0 }}>
                        {this.state[index] ? (
                          [
                            <input
                              autoFocus
                              type="text"
                              className="item-caption col-xs-10"
                              placeholder="Add caption here"
                              ref={(ref) => {
                                this[index] = ref;
                              }}
                              value={this.state[item.id]}
                              onChange={(e) =>
                                this.setState({ [item.id]: e.target.value })
                              }
                              onKeyPress={(e) =>
                                this.onEnter(
                                  e,
                                  item.caption,
                                  item.id,
                                  this.state[item.id],
                                  index
                                )
                              }
                              onBlur={() =>
                                this.onSaveCaption(
                                  item.caption,
                                  item.id,
                                  this.state[item.id],
                                  index
                                )
                              }
                            />,
                            <button
                              className="btn-file-caption btn-file-caption--check col-xs-1"
                              onClick={() =>
                                this.onSaveCaption(
                                  item.caption,
                                  item.id,
                                  this.state[item.id],
                                  index
                                )
                              }
                            >
                              <i className="fa fa-check" />
                            </button>,
                            <button
                              className="btn-file-caption btn-file-caption--cancel col-xs-1"
                              onMouseDown={() => {
                                this.setState({
                                  [item.id]: item.caption,
                                  [index]: false,
                                });
                              }}
                            >
                              <i className="fa fa-close" />
                            </button>,
                          ]
                        ) : (
                          <label
                            className="label-caption col-xs-12"
                            style={
                              !item.caption
                                ? { color: "#ccc" }
                                : { color: "#595959" }
                            }
                            onClick={() => this.setState({ [index]: true })}
                          >
                            {item.caption ? item.caption : "Add caption here"}
                          </label>
                        )}
                      </div>
                    </div>
                  )
                )
              ) : (
                <div>
                  <img
                    className="work-order-no-files-ic"
                    src={folder}
                    alt="no-files"
                  />
                  <p className="work-order-no-files">No files 2</p>
                </div>
              )}
              {this.state.files.map((item, index) => (
                <div className="file-item col-xs-12" key={index}>
                  <div
                    className="item-thumbnail"
                    style={this.renderFileTypeUploading(item)}
                  >
                    <i className="fa fa-spin fa-spinner ic-loading" />
                    <i
                      className="fa fa-times-circle ic-stop"
                      onClick={() => this.handleCancel(item)}
                    />
                  </div>
                  <p className="item-name">{removeDiacritics(item.name)}</p>
                </div>
              ))}
            </div>
            {AppSettings.clientTypeValue === "Subcontractor"
              ? !this.props.readOnly &&
                this.props.WorkOrderProfile.viewOnly === false && (
                  <div className="files-bottom">
                    <p>
                      <span className="files-upload-ic">
                        <i className="fa fa-cloud-upload" />
                      </span>
                      Drag files here or{" "}
                      <span
                        className="files-browse-txt"
                        onClick={() => {
                          this.dropzoneRef.open();
                        }}
                      >
                        browse.
                      </span>
                    </p>
                  </div>
                )
              : !this.props.readOnly && (
                  <div className="files-bottom">
                    <p>
                      <span className="files-upload-ic">
                        <i className="fa fa-cloud-upload" />
                      </span>
                      Drag files here or{" "}
                      <span
                        className="files-browse-txt"
                        onClick={() => {
                          this.dropzoneRef.open();
                        }}
                      >
                        browse.
                      </span>
                    </p>
                  </div>
                )}
          </Dropzone>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WorkOrderAttachments: state.WorkOrderReducer.WorkOrderAttachments,
    WorkOrderCredentials: state.WorkOrderReducer.Credentials,
    WorkOrderProfile: state.WorkOrderReducer.WorkOrderProfile,
    LotStore: state.LotStore,
  };
};

export default connect(mapStateToProps)(WorkOrderFiles);



// WEBPACK FOOTER //
// ./src/Work-Orders/Containers/work-order-file.js